<div
  #box
  class="resizable-draggable active"
  [ngStyle]="diffWidth && { width: diffWidth + 'px' }"
  [class.w-100]="isFlex"
  [style.min-width.px]="min">
  <ng-content></ng-content>
  <div *ngIf="isResize" #resizeAction class="resize-action" [class.isLast]="isLast"></div>
</div>
